import { render, staticRenderFns } from "./DashboardWidgetTermineAllgemein.vue?vue&type=template&id=1500822c&scoped=true"
import script from "./DashboardWidgetTermineAllgemein.vue?vue&type=script&lang=js"
export * from "./DashboardWidgetTermineAllgemein.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1500822c",
  null
  
)

export default component.exports